import {
    apiRequest,
    kgbPeriodDetail,
    kgbExportUsulan,
    kgbExportLampiran,
    kgbProcess,
    kgbDownloadDraftSK,
    kgbInputSK,
    createSKCollective,
    listSKCollective,
    downloadSKCollective,
    generatePegawai,
    signatoriesList
} from "../../../../../services/adapters/kepegawaian/kgbService"

class IndexRepository {

    fetchPeriodDetail = async (query) => {
        return await apiRequest("get", kgbPeriodDetail, {
            params: query
        }, true)
    }
    
    fetchGenerate = async (query) => {
        return await apiRequest("post", generatePegawai, {
            body: query
        }, true)
    }

    fetchExportUsulan = async (query) => {
        return await apiRequest("get", kgbExportUsulan, {
            params: query
        }, true)
    }

    fetchExportLampiran = async (query) => {
        return await apiRequest("get", kgbExportLampiran, {
            params: query
        }, true)
    }

    fetchProcess = async (query) => {
        return await apiRequest("post", kgbProcess, {
            body: query
        }, true)
    }

    fetchDownloadDraftSK = async (query) => {
        return await apiRequest("get", kgbDownloadDraftSK, {
            params: query
        }, true)
    }

    fetchInputSK = async (query) => {
        return await apiRequest("post", kgbInputSK, {
            body: query
        }, true)
    }

    fetchCreateSKC = async (query) => {
        return await apiRequest("post", createSKCollective, {
            body: query
        }, true)
    }

    fetchListSKC = async (query) => {
        return await apiRequest("get", listSKCollective, {
            params: query
        }, true)
    }

    fetchDownloadSKC = async (query) => {
        return await apiRequest("get", downloadSKCollective, {
            params: query
        }, true)
    }
    
    fetchSignatories = async (query) => {
        return await apiRequest("get", signatoriesList, {
            params: query
        }, true)
    }
}

export default IndexRepository